export default __webpack_public_path__ + "static/media/gallery_04.f53ad527.jpg";